export default __webpack_public_path__ + "locales/pl/DeleteSelfProfileDialog.json?hash=409d000822bc5d6b3e581378085a58ff";